const ContactModel = {};

ContactModel.Phone = {
  id: 1,
  title: 'Phone',
  logo: '/images/icons/phone.svg',
};

ContactModel.Discord = {
  id: 2,
  title: 'Discord',
  botLink: process.env.DISCORD_BOT_PRO_LINK,
  logo: '/images/messengers/discord.svg',
  metaField: 'discord_channel_id',
};

ContactModel.Telegram = {
  id: 3,
  title: 'Telegram',
  botLink: process.env.TELEGRAM_BOT_PRO_LINK,
  logo: '/images/messengers/telegram.svg',
  metaField: 'telegram_user_id',
};

ContactModel.Facebook = {
  id: 4,
  title: 'Facebook',
  logo: '/images/messengers/facebook.svg',
};

ContactModel.WhatsApp = {
  id: 5,
  title: 'WhatsApp',
  logo: '/images/messengers/whatsapp.svg',
};

ContactModel.LIST = [
  ContactModel.Phone,
  ContactModel.Discord,
  ContactModel.Telegram,
  ContactModel.Facebook,
  ContactModel.WhatsApp,
];

ContactModel.ID_TO_DATA = {
  [ContactModel.Telegram.id]: ContactModel.Telegram,
  [ContactModel.Discord.id]: ContactModel.Discord,
  [ContactModel.Phone.id]: ContactModel.Phone,
  [ContactModel.Facebook.id]: ContactModel.Facebook,
  [ContactModel.WhatsApp.id]: ContactModel.WhatsApp,
};

ContactModel.LIST_BOT = [
  ContactModel.Telegram,
  // ContactModel.Discord, Вырубаем дискорд до обновления флоу
];

ContactModel.ID_TO_BOT_DATA = {
  [ContactModel.Telegram.id]: ContactModel.Telegram,
  [ContactModel.Discord.id]: ContactModel.Discord,
};

export default ContactModel;
